import CloseIcon from "@mui/icons-material/Close";
import { Drawer, Grid, InputLabel, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import * as React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { baseURL } from "../common/api/apiUris";
import { useDealerCompany } from "../common/hooks";
import { layoutStyle } from "../pages/layout-ui/style";

export default function CompanyForm({
  open,
  setOpen,
  title,
  setRefreshData,
  editValue,
}) {
  const classes = layoutStyle();
  const [binaryImage, setBinaryImage] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [imageName, setImageName] = useState(null);
  const { getDealerCompanyListApi } = useDealerCompany();
  const dealerId = parseInt(localStorage.getItem("cashflow_admin_user_id"));
  const typeId = parseInt(localStorage.getItem("typeId"));
  let data = new FormData();

  const handleClose = () => {
    setBinaryImage(null);
    setCompanyName(null);
    setOpen(false);
  };

  const defaultValue = {
    companyName: "",
    companyLogo: null,
  };

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: defaultValue,
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    // resolver: yupResolver(schema),
  });
  const onSubmit = async () => {
    try {
      data.append("ImageFile", binaryImage);
      data.append("CompanyImage", binaryImage);
      data.append("CompanyImageName", imageName);
      data.append("CompanyName", companyName);
      data.append("Deleted", false);
      let response;
      if (data && title === "Edit Company") {
        data.append("id", Number(editValue?.companyId));
        // data.append("companyId", Number(editValue?.companyId));
        // data.append("dealerId", Number(typeId));
        // data.append("userId", deditValue?.ealerId);
        axios({
          url: `${baseURL}/Company/Update`,
          data: data,
          method: "post",
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then((res) => {
            setRefreshData(true);
          })
          .finally(async () => {
            await getDealerCompanyListApi({ dealerId: typeId });
          });
      } else {
        response = await axios({
          url: `${baseURL}/Company/Create`,
          data: data,
          method: "post",
          headers: { "Content-Type": "multipart/form-data" },
        });
        const companyId = response?.data?.data;

        if (companyId) {
          await axios({
            url: `${baseURL}/DealerCompany/Create`,
            data: { dealerId: typeId, companyId: companyId },
            method: "post",
            headers: { "Content-Type": "application/json" },
          });
        }
        setRefreshData(true);
        await getDealerCompanyListApi({ dealerId: typeId });
        // .then((res) => {
        //   setRefreshData(true);
        // })
        // .finally(async () => {
        //   await getDealerCompanyListApi({ dealerId: dealerId });
        // });
      }

      handleClose();
    } catch (error) {
      console.error("Error creating/updating company:", error);
    }
  };

  useEffect(() => {
    data.delete("ImageFile");
    data.delete("CompanyName");
    data.delete("Deleted");
  }, [open]);

  useEffect(() => {
    if (editValue) {
      setCompanyName(editValue?.companyName);
    }
  }, [editValue]);

  const imageToBinary = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const binaryString = reader.result;
        resolve(binaryString);
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsBinaryString(file);
    });
  };

  const handleCompanyLogo = async (event) => {
    setImageName(event?.timeStamp);
    let file = event.target.files[0];

    try {
      const binaryData = await imageToBinary(file);
      setBinaryImage(file); // Output the binary data to console
    } catch (error) {
      console.error("Error converting image to binary:", error);
    }
  };

  const handleCompanyName = (event) => {
    setCompanyName(event.target.value);
  };

  return (
    <React.Fragment>
      <Drawer
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
        anchor="bottom"
        fullHeight
        style={{ top: "100px ", bottom: "56px !important" }}
        className="DrawerName"
      >
        <DialogTitle
          className={classes.dailogTitle}
          id="customized-dialog-title"
        >
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container className={classes.disFlexCenter}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid className={classes.companyForm}>
                <Grid className={classes.compnayFormField}>
                  <InputLabel className={classes.fontSize12}>
                    Company Name
                  </InputLabel>
                  <TextField
                    // error={errors?.companyName}
                    type="text"
                    fullWidth
                    value={companyName}
                    onChange={handleCompanyName}
                  />
                </Grid>
                <Grid className={classes.compnayFormField}>
                  <InputLabel className={classes.fontSize12}>
                    Company Logo
                  </InputLabel>
                  <TextField
                    error={errors?.companyLogo}
                    type="file"
                    onChange={handleCompanyLogo}
                    fullWidth
                    inputProps={{
                      accept: "image/jpeg, image/png, image/gif, image/bmp",
                    }}
                    // {...register("companyLogo")}
                  />
                </Grid>

                <Button
                  variant="outlined"
                  type="submit"
                  className={classes.fleetListNewButton}
                  autoFocus
                  sx={{ mt: 3, height: "50px" }}
                >
                  {title}
                </Button>
              </Grid>
            </form>
          </Grid>
        </DialogContent>
      </Drawer>
    </React.Fragment>
  );
}
